import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function CategoryPage() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState(null);

  useEffect(() => {
    api.get(`/products?category=${slug}`).then((r) => setProducts(r.data));
    api.get("/categories").then((r) => {
      const found = r.data.find((c) => c.slug === slug);
      setCat(found);
    });
  }, [slug]);

  return (
    <div data-testid={`category-page-${slug}`}>
      <div className="relative h-72 md:h-96 overflow-hidden">
        {cat?.image_url && <img src={cat.image_url} alt="" className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/80 to-[#0A192F]/20" />
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 h-full flex items-end pb-10">
          <div className="text-white">
            <Link to="/shop" className="text-sm uppercase tracking-widest text-[#F9F6F0]/80 hover:text-[#E65A28]">← Shop</Link>
            <h1 className="font-serif text-5xl md:text-6xl mt-2">{cat?.name || slug}</h1>
            <p className="mt-2 text-[#F9F6F0]/80 max-w-lg">{cat?.description}</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        {products.length === 0 ? (
          <p className="text-center text-[#666] py-20">No products in this category yet.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
            {products.map((p) => <ProductCard key={p.product_id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
